<template>
  <div>
    <template v-if="isNoti">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-with-icon"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center"
      >
        <button
            type="button"
            aria-hidden="true"
            class="close"
            data-notify="dismiss"
            @click="close"
        >
          ×
        </button>
        <i data-notify="icon" class="material-icons" v-if="icon">{{ icon }}</i>
        <span data-notify="message" v-html="message"></span>
      </div>

    </template>
    <template v-if="isFirebaseNoti">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-firebase"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center"
      >
        <router-link :to="firebaseNotiContent.url" @click.native="reloadMessengerFromUrl(firebaseNotiContent.url)">
          <md-list-item class="p-0px m-0px">
            <!--            <md-avatar>-->
            <!--              <img class="avatar" :src="firebaseNotiContent.image ? firebaseNotiContent.image:'/img/profile/avatar.png'">-->
            <!--            </md-avatar>-->
            <div class="message text-300-default">
              <template v-if="firebaseNotiContent.type == NOTIFICATION_TYPE.ADD_MEMBER">
                Bạn đã được <span class="text-300-medium">{{
                  detectData(detectData(firebaseNotiContent.data)).user.name
                }}</span> thêm vào <span class="text-300-medium">{{
                  detectData(firebaseNotiContent.data).group.name
                }}</span>
              </template>
              <template v-if="firebaseNotiContent.type == NOTIFICATION_TYPE.CREATE_POST">
                <span class="text-300-medium">{{ detectData(firebaseNotiContent.data).user.name }}</span> đã đăng bài
                vào <span class="text-300-medium">{{ detectData(firebaseNotiContent.data).group.name }}</span>
              </template>
              <template v-if="firebaseNotiContent.type == NOTIFICATION_TYPE.LIKE_POST">
                <span class="text-300-medium">{{ detectData(firebaseNotiContent.data).user.name }}</span> đã thích bài
                viết của bạn trong <span class="text-300-medium">{{
                  detectData(firebaseNotiContent.data).group.name
                }}</span>
              </template>
              <template v-if="firebaseNotiContent.type == NOTIFICATION_TYPE.COMMENT_POST">
                <template
                    v-if="detectData(firebaseNotiContent.data).created_by && detectData(firebaseNotiContent.data).created_by.id != user.id">
                  <span class="text-300-medium">{{ detectData(firebaseNotiContent.data).user.name }}</span> đã bình luận
                  bài viết của <span class="text-300-medium">{{
                    detectData(firebaseNotiContent.data).created_by.name
                  }}</span> trong <span class="text-300-medium">{{
                    detectData(firebaseNotiContent.data).group.name
                  }}</span>
                </template>
                <template v-else>
                  <span class="text-300-medium">{{ detectData(firebaseNotiContent.data).user.name }}</span> đã bình luận
                  bài viết của bạn trong <span
                    class="text-300-medium">{{ detectData(firebaseNotiContent.data).group.name }}</span>
                </template>
              </template>
              <div class="create-time mt-5px">{{ fromNow(firebaseNotiContent.created_at) }}</div>
            </div>
          </md-list-item>
        </router-link>
      </div>
    </template>

    <template v-if="mentioned">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-firebase"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center">

        <div class="header">
          <span class="text-400-medium neutral_2">Đề cập trong tin nhắn</span>
          <md-icon class="float-right neutral_2">close</md-icon>
        </div>
        <router-link :to="'/messenger/' + (chatContent.group_id || chatContent.chat_group_id || (chatContent.group && chatContent.group.id))">
          <md-list-item class="message-noti">
            <div class="mr-10px" style="position: relative">
              <md-avatar>
                <image-template
                  class="chat-noti-avatar"
                  :size="'small'"
                  :image="chatSenderAvatarUrl"
                  :thumbnail="chatContent.sender && chatContent.sender.thumbnail"
                  :name="chatSenderName"
                />
              </md-avatar>
              <div class="reaction">
                <md-icon>alternate_email</md-icon>
              </div>
            </div>
            <div class="text-content">
              <div class="text-content__header text-1-line mb-5px">
                <span>{{ chatContent.group.name }}</span>
              </div>
              <div class="text-2-line mb-2px">
                <span class="d-inline" style="font-weight: 500">{{ chatContent.sender.display_name || chatContent.sender.fullname }}</span> đã đề cập đến bạn
              </div>
              <div class="text-content__message">
                <span class="material-icons">format_quote</span>
                <span class="text-3-line">{{ chatContent.text }}</span>
              </div>
              <div class="text-300-default create-time secondary_b400">Vừa xong</div>
            </div>
          </md-list-item>
        </router-link>
      </div>
    </template>

    <template v-else-if="replied">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-firebase"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center">

        <div class="header">
          <span class="text-400-medium neutral_2">Trả lời tin nhắn</span>
          <md-icon class="float-right neutral_2">close</md-icon>
        </div>
        <router-link :to="'/messenger/' + (chatContent.group_id || chatContent.chat_group_id || (chatContent.group && chatContent.group.id))">
          <md-list-item class="message-noti">
            <div class="mr-10px" style="position: relative">
              <md-avatar>
                <image-template
                  class="chat-noti-avatar"
                  :size="'small'"
                  :image="chatSenderAvatarUrl"
                  :thumbnail="chatContent.sender && chatContent.sender.thumbnail"
                  :name="chatSenderName"
                />
              </md-avatar>
              <div class="reaction">
                <md-icon>reply</md-icon>
              </div>
            </div>
            <div class="text-content">
              <div class="text-content__header text-1-line mb-5px">
                <span>{{ chatContent.group.name }}</span>
              </div>
              <div class="text-2-line mb-2px">
                <span class="d-inline" style="font-weight: 500">{{ chatContent.sender.display_name || chatContent.sender.fullname }}</span> đã trả lời tin nhắn của bạn
              </div>
              <div class="text-content__message">
                <span class="material-icons">format_quote</span>
                <span class="text-3-line">{{ chatContent.text }}</span>
              </div>
              <div class="text-300-default create-time secondary_b400">Vừa xong</div>
            </div>
          </md-list-item>
        </router-link>
      </div>
    </template>

    <template v-else-if="isChatNoti">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-firebase"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center"
      >
        <div class="header">
          <span class="text-400-medium neutral_2">Tin nhắn mới</span>
          <md-icon class="float-right neutral_2">close</md-icon>
        </div>
        <!-- <router-link @click="goToChat" :to="'/messenger/'+chatContent.group_id"> -->
          <md-list-item class="message-noti cursor-pointer" @click="goToChat">
            <md-avatar>
              <image-template
                v-if="chatContent.group && chatContent.group.type === 'USER'"
                class="chat-noti-avatar"
                :size="'small'"
                :image="chatSenderAvatarUrl"
                :thumbnail="chatContent.sender && chatContent.sender.thumbnail"
                :name="chatSenderName"
              />
              <image-template
                v-else
                class="chat-noti-avatar"
                :size="'small'"
                :image="chatGroupAvatarImage"
                :thumbnail="chatContent.group && chatContent.group.thumbnail"
                :name="chatContent.group && chatContent.group.name"
                img-type="group"
              />
            </md-avatar>
            <div class="text-content">
              <div class="text-content__header text-1-line mb-2px">
                <span v-if="chatContent.group.type === 'USER'">{{ chatContent.sender.display_name || chatContent.sender.fullname}}</span>
                <span v-else>{{ chatContent.group.name }}</span>
              </div>
              <div class="text-content__message">
                <span class="material-icons">format_quote</span>
                <span v-if="chatContent.group.type === 'USER'" class="text-3-line">{{ chatContent.text }}</span>
                <span v-else class="text-3-line">{{chatContent.sender.fullname}} : {{ chatContent.text }}</span>
              </div>
              <div class="text-300-default create-time secondary_b400">Vừa xong</div>
            </div>
          </md-list-item>
        <!-- </router-link> -->
      </div>
    </template>

    <template v-else-if="isChatNotiReaction">
      <div
          @click="close()"
          data-notify="container"
          class="alert open alert-firebase"
          role="alert"
          :class="[verticalAlign, horizontalAlign, alertType]"
          :style="customPosition"
          data-notify-position="top-center">

        <div class="header">
          <span class="text-400-medium neutral_2">Tương tác tin nhắn</span>
          <md-icon class="float-right neutral_2">close</md-icon>
        </div>
        <router-link :to="'/messenger/' + (chatContent.group_id || chatContent.chat_group_id || (chatContent.group && chatContent.group.id))">
          <md-list-item class="message-noti">
            <div class="mr-10px" style="position: relative">
              <md-avatar>
                <image-template
                  class="chat-noti-avatar"
                  :size="'small'"
                  :image="chatReactorAvatarUrl"
                  :thumbnail="chatContent.user_reacted && chatContent.user_reacted.thumbnail"
                  :name="chatReactorName"
                />
              </md-avatar>
              <div class="reaction" :class="'reaction-' + chatContent.reaction"></div>
            </div>
            <div class="text-content">
              <div class="text-content__header text-2-line mb-2px">
                <span class="d-inline" style="font-weight: 500">{{ chatContent.user_reacted.display_name || chatContent.user_reacted.fullname }}</span> đã tương tác với tin nhắn của bạn
              </div>
              <div class="text-content__message">
                <span class="material-icons">format_quote</span>
                <span class="text-3-line">{{ chatContent.message.text }}</span>
              </div>
              <div class="text-300-default create-time secondary_b400">Vừa xong</div>
            </div>
          </md-list-item>
        </router-link>
      </div>
    </template>
  </div>
</template>
<script>
  import {NOTIFICATION_TYPE} from "../../const/const";
  import ChatService from "../../store/services/ChatService";
  import ImageTemplate from "../ImageTemplate";
  import { chatGroupAvatarUrl } from "../../helper/notificationAvatar";
  import { chatSenderDisplayName, chatSenderThumbUrl } from "../../helper/chatSenderAvatar";
  import moment from "moment";

  export default {
    name: "notification",
    components: {
      ImageTemplate,
    },
    props: {
      message: String,
      icon: String,
      verticalAlign: {
        type: String,
        default: "top"
      },
      horizontalAlign: {
        type: String,
        default: "center"
      },
      type: {
        type: String,
        default: "info"
      },
      timeout: {
        type: Number,
        default: 10500
      },
      timestamp: {
        type: Date,
        default: () => new Date()
      },
      isNoti: {
        type: Boolean,
        default: false
      },
      isFirebaseNoti: {
        type: Boolean,
        default: false
      },
      firebaseNotiContent: {
        type: Object,
        default: () => {
          return {};
        }
      },
      isChatNoti: {
        type: Boolean,
        default: false
      },
      isChatNotiReaction: {
        type: Boolean,
        default: false
      },
      chatContent: {
        type: Object,
        default: () => {
          return {};
        }
      },
    },
    data() {
      return {
        elmHeight: 0,
        NOTIFICATION_TYPE: NOTIFICATION_TYPE,
        user: this.$store.state.auth.user,
      };
    },
    computed: {
      replied() {
        return this.isChatNoti && this.chatContent.reply_to_msg && this.chatContent.reply_to_msg.sender.id == this.user.id
      },
      mentioned() {
        let user_id = this.user.id;
        
        let myMention = [];
        if(this.chatContent.mentions){
          myMention = this.chatContent.mentions.filter(function (el) {
            return el.mention_user_id == user_id
          });
        }
        return this.isChatNoti && myMention.length > 0
      },
      hasIcon() {
        return this.icon && this.icon.length > 0;
      },
      alertType() {
        return `alert-${this.type}`;
      },
      isBottomCardNoti() {
        return this.isFirebaseNoti
          || this.isChatNoti
          || this.isChatNotiReaction
          || this.mentioned
          || this.replied;
      },
      customPosition() {
        const initialMargin = 20;
        const stepHeight = this.isBottomCardNoti
          ? 110
          : Math.max(this.elmHeight, 48) + 10;
        const sameAlertsCount = this.$notifications.state.filter(alert => {
          return (
            alert.horizontalAlign === this.horizontalAlign &&
            alert.verticalAlign === this.verticalAlign &&
            alert.timestamp <= this.timestamp
          );
        }).length;
        const pixels = (sameAlertsCount - 1) * stepHeight + initialMargin;
        const styles = {};

        if (this.verticalAlign === "top") {
          styles.top = `${pixels}px`;
        } else {
          styles.bottom = `${pixels}px`;
        }

        if (this.horizontalAlign === "right") {
          styles.right = "20px";
        } else if (this.horizontalAlign === "left") {
          styles.left = "20px";
        }

        return styles;
      },
      chatSenderAvatarUrl() {
        return chatSenderThumbUrl(this.chatContent.sender);
      },
      chatSenderName() {
        return chatSenderDisplayName(this.chatContent.sender);
      },
      chatGroupAvatarImage() {
        return chatGroupAvatarUrl(this.chatContent.group);
      },
      chatReactorAvatarUrl() {
        return chatSenderThumbUrl(this.chatContent.user_reacted);
      },
      chatReactorName() {
        return chatSenderDisplayName(this.chatContent.user_reacted);
      },
    },
    methods: {
      close() {
        this.$emit("on-close", this.timestamp);
      },
      detectData(data) {
        return JSON.parse(data)
      },
      fromNow(date) {
        return moment(date).locale("vi").fromNow();
      },
      goToChat(){
        const gid = this.chatGroupIdFromContent(this.chatContent);
        if (!gid) {
          return;
        }
        const params = {
          'page': 1,
          'per_page': 1,
          'group_id': gid
        };

      ChatService.getChatGroups(params).then(res => {
        if (res.data) {
          this.$store.commit("chat/updateChatGroupSelected", res.data[0]);
        }
      });

      const path = '/messenger/' + gid;
      this.$router.push(path).catch(() => {});
      this.$root.$emit('messenger:reload-conversation', String(gid));
      },
      chatGroupIdFromContent(content) {
        if (!content || typeof content !== 'object') return '';
        return content.group_id || content.chat_group_id || (content.group && content.group.id) || '';
      },
      reloadMessengerFromUrl(url) {
        const m = String(url || '').match(/\/messenger\/(\d+)/);
        if (m) {
          this.$root.$emit('messenger:reload-conversation', m[1]);
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        const el = this.$el.querySelector(".alert.open");
        if (el) {
          this.elmHeight = el.getBoundingClientRect().height;
        }
      });
      if (this.timeout) {
        setTimeout(this.close, this.timeout);
      }
    }
  };
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 755px) {
    .alert {
      width: auto !important;
      margin: 0 10px;

      &.left {
        left: 0 !important;
      }

      &.right {
        right: 0 !important;
      }

      &.center {
        margin: 0 10px !important;
      }
    }
  }

  .alert {
    z-index: 100;
    cursor: pointer;
    position: fixed;
    width: 41%;

    &.center {
      left: 0;
      right: 0;
      margin: 0 auto;
    }

    &.left,
    &.right,
    &.center {
      margin-top: 10px;
    }

    &.left {
      left: 20px;
    }

    &.right {
      right: 20px;
    }

    span {
      max-width: none;
    }
  }

  .alert-firebase {
    background-color: white !important;
    width: 450px !important;
    padding: 0px;
    box-shadow: -2px -1px 20px -10px rgb(0 0 0 / 16%), 1px 1px 4px 0px rgb(0 0 0 / 28%) !important;

    .header {
      padding: 8px 10px;
      border-bottom: 1px solid #d8d8d8;
      span {
        display: inline;
      }
      .md-icon {
        font-size: 20px !important;
        font-weight: 600;
      }
    }

    a {
      color: black !important;
    }
    .message-noti {
      margin: 0 !important;

      .md-list-item-content {
        align-items: start !important;
        justify-content: start !important;
      }

      span {
        white-space: break-spaces;
      }

      .md-avatar, .md-avatar img, .chat-noti-avatar {
        width: 50px !important;
        height: 50px !important;
        border-radius: 50%;
        border: 1px solid #dadada;
      }
      .reaction {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 20px;
        height: 20px;
      }
      .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;
        font-size: 13px;
        .text-content__header{
          font-weight: 500;
        }
        .text-content__message {
          margin-bottom: 6px;
          display: flex;
          align-items: start;
          .material-icons {
            transform: rotate(180deg);
            color: #9d9d9d;
            font-size: 14px;
            padding: 4px 0 0 0;
            margin-right: 2px;
          }
          span {
            display: -webkit-box;
          }
        }
      }
    }
  }
</style>
